import { ComponentFactoryResolver, Directive, OnInit, ViewContainerRef } from '@angular/core';
import { SwProcessPageUiService } from '../../../../service/ui/sw-process-page-ui.service';
import { SwDiscardModalComponent } from '../sw-discard-modal/sw-discard-modal.component';

@Directive({
  selector: '[sw-discard-host]'
})
export class SwDiscardHostDirective implements OnInit {
  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private swProcessPageUiService: SwProcessPageUiService
  ) {}

  ngOnInit() {
    this.swProcessPageUiService.isSwDiscardModalActive$.subscribe({
      next: (discardModal) => {
        if (discardModal.isActive) {
          this.loadModal();
        } else {
          this.clearModal();
        }
      }
    });
  }

  private loadModal(): void {
    this.viewContainerRef.clear();

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(SwDiscardModalComponent);
    this.viewContainerRef.createComponent(componentFactory);
  }

  private clearModal(): void {
    this.viewContainerRef.clear();
  }


}
